export default "__VITE_ASSET__CfhzGOAz__"